class ItemsYouCanSell extends HTMLElement {
  connectedCallback() {
    if (this.dataset.tabsReady === 'true') return;

    this.tabs = Array.from(this.querySelectorAll('[data-items-you-can-sell-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-items-you-can-sell-panel]'));
    if (!this.tabs.length || this.tabs.length !== this.panels.length) return;

    this.tabList = this.querySelector('[role="tablist"]');
    this.desktopTabOrder = this.tabs.map((tab) => tab.dataset.metal);
    this.mobileMedia = window.matchMedia('(max-width: 767px)');
    this.handleViewportChange = () => this.syncResponsiveState();

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activateTab(tab));
      tab.addEventListener('keydown', (event) => this.handleKeydown(event));
    });

    const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
    this.dataset.tabsReady = 'true';
    this.activateTab(selectedTab, { focus: false });
    this.syncResponsiveState();
    this.mobileMedia.addEventListener('change', this.handleViewportChange);
  }

  disconnectedCallback() {
    this.mobileMedia?.removeEventListener('change', this.handleViewportChange);
  }

  activateTab(nextTab, { focus = true } = {}) {
    const controlledPanelId = nextTab.getAttribute('aria-controls');

    this.tabs.forEach((tab) => {
      const isSelected = tab === nextTab;
      tab.setAttribute('aria-selected', String(isSelected));
      tab.setAttribute('tabindex', isSelected ? '0' : '-1');
      tab.classList.toggle('is-active', isSelected);
    });

    this.panels.forEach((panel) => {
      const isSelected = panel.id === controlledPanelId;
      panel.hidden = !isSelected;
      panel.classList.toggle('is-active', isSelected);
    });

    if (focus) nextTab.focus();
  }

  handleKeydown(event) {
    const navigableTabs = this.getNavigableTabs();
    const currentIndex = navigableTabs.indexOf(event.currentTarget);
    let nextIndex;

    switch (event.key) {
      case 'ArrowRight':
        nextIndex = (currentIndex + 1) % navigableTabs.length;
        break;
      case 'ArrowLeft':
        nextIndex = (currentIndex - 1 + navigableTabs.length) % navigableTabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = navigableTabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.activateTab(navigableTabs[nextIndex]);
  }

  getNavigableTabs() {
    return this.tabs
      .filter((tab) => getComputedStyle(tab).display !== 'none')
      .sort((firstTab, secondTab) => {
        const firstOrder = Number.parseInt(getComputedStyle(firstTab).order, 10) || 0;
        const secondOrder = Number.parseInt(getComputedStyle(secondTab).order, 10) || 0;
        return firstOrder - secondOrder;
      });
  }

  syncResponsiveState() {
    const isMobile = this.mobileMedia.matches;
    const tabOrder = isMobile ? ['gold', 'platinum', 'silver', 'palladium'] : this.desktopTabOrder;

    tabOrder.forEach((metal) => {
      const tab = this.tabs.find((candidate) => candidate.dataset.metal === metal);
      if (tab) this.tabList.append(tab);
    });

    const navigableTabs = this.getNavigableTabs();
    const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');

    this.querySelectorAll('[data-mobile-url][data-desktop-url]').forEach((link) => {
      link.href = isMobile ? link.dataset.mobileUrl : link.dataset.desktopUrl;
    });

    if (!navigableTabs.includes(selectedTab)) {
      this.activateTab(navigableTabs[0], { focus: false });
    }
  }
}

if (!customElements.get('items-you-can-sell')) {
  customElements.define('items-you-can-sell', ItemsYouCanSell);
}
